export const getHistoryValue = (display: null | string, raw: null | string) => display || raw || '-'

export const hasHistoryValue = (display: null | string, raw: null | string) =>
  Boolean(display || raw)
